import { render } from "./BenchmarkingAnalysis.vue?vue&type=template&id=19ff44dc"
import script from "./BenchmarkingAnalysis.vue?vue&type=script&lang=js"
export * from "./BenchmarkingAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__